export const HEADING_FONT = "Poppins";
export const BODY_FONT = "Questrial";

export const FONT_0_5 = "0.5rem";
export const FONT_0_625 = "0.625rem";
export const FONT_0_75 = "0.75rem";
export const FONT_0_875 = "0.875rem";
export const FONT_1 = "1rem";
export const FONT_1_125 = "1.125rem";
export const FONT_1_25 = "1.25rem";
export const FONT_1_5 = "1.5rem";
